<!-- <div class="overview-navigation">
    <div class="forward-page">Analytics</div>
</div> -->

<div class="analytics-container">
  <div class="custom-section card">
    <div class="heading">
      <div>
        <h2 class="title">Analytics</h2>
        <p>Take a look at your group performance breakdown</p>
      </div>
      <!-- <div class="dropdown-container">
           
            <div *ngIf="load == true">
            <p class="dates">{{startDate}} to {{currentDate}}</p>
            </div>
            
            </div> -->
    </div>

    <div class="sub-heading">
      <h3>Client Level Analytics</h3>
      <p class="subtext">View customer analytics below</p>
    </div>

    <div class="dropdown-container">
      <div class="">
        <app-dropdown
          *ngIf="currentRole === Roles.superAdmin"
          [options]="companies"
          selectedItem="{{ selectedValues.company }}"
          (onSelectOption)="setSelectedCompany($event)"
          [fields]="['companyId', 'companyName']"
          [ngStyle]="currentRole === Roles.admin ? specialStyle : defaultStyle"
          [label]="
            selectedValues.company.companyName === ''
              ? 'Choose Account Holder'
              : selectedValues.company.companyName
          "
        ></app-dropdown>

        <app-dropdown
          [disabled]="
            selectedValues.company.companyName.length === 0 &&
            currentRole === Roles.superAdmin
          "
          [options]="plants"
          selectedItem="{{ selectedValues.plant }}"
          (onSelectOption)="setPlant($event)"
          [fields]="['plantId', 'plantName']"
          [ngStyle]="currentRole === Roles.admin ? specialStyle : defaultStyle"
          [label]="
            resetPlant || selectedValues.plant.plantName === ''
              ? 'Choose Client'
              : selectedValues.plant.plantName
          "
        ></app-dropdown>
      </div>
      <app-dropdown
        [disabled]="false"
        [options]="options"
        [selectedItem]="selectedOption"
        (onSelectOption)="setSelection($event)"
        [fields]="['optionId', 'optionName', 'days']"
        [inputStyle]="defaultStyle"
        [label]="selectedOption.optionName"
      >
      </app-dropdown>

      
    </div>

    <div class="chart-container units">
      <div class="label-container">
        <p class="logsheet-count">
          <span class="digits">{{
            (unitAnalytics.Active || 0) + (unitAnalytics.Inactive || 0)
          }}</span>
          Branch(s)
        </p>
        <div class="legend">
          <div class="legend-item">
            <div class="color-legend active-key"></div>
            <div class="desc">Active</div>
          </div>
          <div class="legend-item">
            <div class="color-legend inactive-key"></div>
            <div class="desc">Inactive</div>
          </div>
        </div>
      </div>
      <div class="chart"><canvas id="unit"></canvas></div>
    </div>

    <div class="chart-container chart-container-sheets">
      <div class="label-container">
        <p class="logsheet-count">
          <span class="digits">{{
            (analytics.ExecutedOnTime || 0) +
              (analytics.ExecutedPastDue || 0) +
              (analytics.Incomplete || 0) +
              (analytics.Upcoming || 0) +
              (analytics.NotStarted || 0) +
              (analytics.Overdue || 0)
          }}</span>
          Total Forms
        </p>
        <div class="legend">
          <div class="legend-item">
            <div class="color-legend upcoming-key"></div>
            <div class="desc">Upcoming</div>
          </div>
          <div class="legend-item">
            <div class="color-legend not__started-key"></div>
            <div class="desc">Not Started</div>
          </div>
          <div class="legend-item">
            <div class="color-legend incomplete-key"></div>
            <div class="desc">Incomplete</div>
          </div>
          <div class="legend-item">
            <div class="color-legend executed__on__time-key"></div>
            <div class="desc">Executed On Time</div>
          </div>
          <div class="legend-item">
            <div class="color-legend executed__past__due-key"></div>
            <div class="desc">Executed Past Due</div>
          </div>
          <div class="legend-item">
            <div class="color-legend overdue-key"></div>
            <div class="desc">Overdue</div>
          </div>
        </div>
      </div>
      <div class="chart"><canvas id="total"></canvas></div>
    </div>

    <div class="chart-container group">
      <div class="label-container">
        <p class="logsheet-count">
          <span class="digits">{{ groupsArray.length }}</span> Group(s)
        </p>
        <div class="legend">
          <div class="legend-item">
            <div class="color-legend active-key"></div>
            <div class="desc">Active</div>
          </div>
          <div class="legend-item">
            <div class="color-legend inactive-key"></div>
            <div class="desc">Inactive</div>
          </div>
        </div>
      </div>
      <div class="chart"><canvas id="totalGroup"></canvas></div>
    </div>

    <div class="chart-container datapoints">
      <div class="label-container">
        <p class="logsheet-count">
          <span class="digits">{{ datapointsArray.length }}</span> Form Field(s)
        </p>
        <div class="legend">
          <div class="legend-item">
            <div class="color-legend active-key"></div>
            <div class="desc">Active</div>
          </div>
          <div class="legend-item">
            <div class="color-legend inactive-key"></div>
            <div class="desc">Inactive</div>
          </div>
        </div>
      </div>
      <div class="chart"><canvas id="totalDatapoint"></canvas></div>
    </div>

    <div class="sub-heading">
      <h3>Form Level Analytics</h3>
      <p class="subtext">View form statistics below</p>
    </div>

    <app-dropdown

        [disabled]="selectedValues.plant.plantId === 0"
        [options]="activeForms"
        (onSelectOption)="setSelectedForm($event)"
        [fields]="['logSheetTemplateId', 'logSheetName']"
        [ngStyle]="defaultStyle"
        [label]="
          selectedForm === null
            ? 'Choose Form'
            : selectedForm.logSheetName
        "
      ></app-dropdown>

    <div class="form-statistics-container" *ngIf="formStatistics" #formStatsSection>
      <div class="stats-table">
        <div class="stats-table-header">
          <h3>{{ formStatistics.formName }}</h3>
        </div>
        <table class="stats-table-body">
          <tbody>
            <tr>
              <td class="stat-label">Total Submissions</td>
              <td class="stat-value">{{ formStatistics.totalSubmissions }}</td>
            </tr>
            <tr>
              <td class="stat-label">Num. Unique Respondents</td>
              <td class="stat-value">{{ formStatistics.uniqueRespondents }}</td>
            </tr>
            <tr>
              <td class="stat-label">First Submission Date</td>
              <td class="stat-value">{{ formStatistics.firstSubmissionDate ? (formStatistics.firstSubmissionDate | date: 'dd-MMM-yy') : 'N/A' }}</td>
            </tr>
            <tr>
              <td class="stat-label">Most Recent Submission Date</td>
              <td class="stat-value">{{ formStatistics.mostRecentSubmissionDate ? (formStatistics.mostRecentSubmissionDate | date: 'dd-MMM-yy') : 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-success-toast *ngIf="toastService.showToast"></app-success-toast>
